import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import '@fortawesome/fontawesome-free/css/all.css'
import App from './components/App/App'
import moment from 'moment'
import LOCALE_PT_PT from './resources/locales/pt-PT'

import Polyglot from 'node-polyglot'
import { ConnectedRouter } from 'connected-react-router'
import { Provider } from 'react-redux'
import { basePathConfiguration } from './config'
import createStore from '@kenetto/kenetto-redux'
import reducers from './redux'
import { Route } from 'react-router-dom'
import { throttle } from 'underscore'
import { loadState, saveState } from './resources/localStorage'

const polyglot = new Polyglot()

moment.defineLocale('pt', LOCALE_PT_PT)

export {polyglot}

const persistedState = loadState()

const reduxStore = createStore(basePathConfiguration, reducers, persistedState)

reduxStore.store.subscribe(throttle(() => {
  saveState({
    immunizations: reduxStore.store.getState().immunizations,
    medicines: reduxStore.store.getState().medicines,
    patient: reduxStore.store.getState().patient,
    pathologies: reduxStore.store.getState().pathologies,
    plan: reduxStore.store.getState().plan,
    recommendations: reduxStore.store.getState().recommendations,
    polyglot: reduxStore.store.getState().polyglot,
    currentSelection: reduxStore.store.getState().currentSelection,
    adverseReactions: reduxStore.store.getState().adverseReactions
  })
}, 1000))

ReactDOM.render(<Provider store={reduxStore.store}>
  <ConnectedRouter history={reduxStore.history}>
    <Route path='/' component={App} />
  </ConnectedRouter>
</Provider>, document.getElementById('root'))
